import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getPropertyList, logoutUser } from '../apiCalls';
import { clearStoredUser, getStoredUser } from '../utils/safeLocalStorage';
import * as Sentry from "@sentry/react";

export const usePageLayout = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [companyName, setCompanyName] = useState(() => localStorage.getItem('selectedPropertyName') || '');
    const [propList, setPropList] = useState([]);
    const [activePropertyName, setActivePropertyName] = useState('');
    const [property, setProperty] = useState('');
    const [user, setUser] = useState(null);
    const [role, setRole] = useState('');

    useEffect(() => {
        const parsedUser = getStoredUser();
        const selectedProperty = localStorage.getItem('selectedProperty');
        if (parsedUser) {
            setUser(parsedUser);
            setRole(parsedUser.role);
            fetchPropertyList();
        }
        if (selectedProperty) {
            setProperty(selectedProperty);
            setActivePropertyName(selectedProperty);
        }
    }, []);

    const fetchPropertyList = async () => {
        if (!getStoredUser()) {
            setPropList([]);
            return;
        }

        try {
            const properties = await getPropertyList();
            setPropList(properties);
            const storedProperty = localStorage.getItem('selectedProperty');
            if (storedProperty) {
                const match = properties.find(p => p.propertyID === storedProperty);
                if (match) {
                    setActivePropertyName(match.companyName);
                    setCompanyName(match.companyName);
                    localStorage.setItem('selectedPropertyName', match.companyName);
                }
            }
        } catch (err) {
            Sentry.captureException(err);
        }
    };

    const chooseProperty = (prop) => {
        setProperty(prop);
        const match = propList.find(p => p.propertyID === prop);
        const name = match ? match.companyName : prop;
        setActivePropertyName(name);
        setCompanyName(name);
        localStorage.setItem('selectedProperty', prop);
        localStorage.setItem('selectedPropertyName', name);

        const propertyRoutes = ['/variables/', '/rules/', '/custom-costs/', '/pdf-content/', '/images/', '/cost-table/', '/pdf-layout/', '/pdf-designer/', '/email-config/'];
        const matchedRoute = propertyRoutes.find(r => pathname.startsWith(r));
        if (matchedRoute) {
            navigate(`${matchedRoute}${prop}`);
        }
    };

    const signOut = async () => {
        try {
            await logoutUser();
        } catch (err) {
            Sentry.captureException(err);
        }
        clearStoredUser();
        localStorage.removeItem('selectedProperty');
        localStorage.removeItem('selectedPropertyName');
        window.location.href = '/login';
    };

    const confirmIfDirty = (callback) => {
        callback();
    };

    return {
        companyName,
        chooseProperty,
        propList,
        activePropertyName,
        property,
        role,
        signOut,
        confirmIfDirty,
        user,
    };
};
